import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { CnaeImpedidoRoutingModule } from "./cnae-impedido-routing.module";
import { CnaeImpedidoListagemComponent } from "./listagem/cnae-impedido-listagem.component";
import { CnaeImpedidoPesquisaComponent } from "./pesquisa/cnae-impedido-pesquisa.component";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";


@NgModule({
  imports: [ SharedModule,
            BrowserModule,
            CommonModule,
            CnaeImpedidoRoutingModule, BnConfirmDirective],
  exports: [],
  declarations: [CnaeImpedidoPesquisaComponent,
                  CnaeImpedidoListagemComponent],
  providers: [],
  schemas: []
})
export class CnaeImpedidoModule { }
